import React, { useState, useEffect } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import API from "../../actions";
import {
    Typography
  
} from "@material-ui/core";
const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black
    },
    body: {
        fontSize: 14
    }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.background.default
        },
        cursor: "pointer"
    }
}))(TableRow);

const useStyles = makeStyles({
    table: {
        minWidth: 700
    }
});

export default props => {
    const classes = useStyles();
    const [rows, setRows] = useState(null);

    useEffect(() => {
        (async () => setRows(await API.clientGetTreatmentsFromTherapist(props.therapistId,props.clientId)))();
    }, [props.therapistId]);
    
    if (!rows || rows.length === 0) return <>
        <Typography color="secondary">Klinikken kan desværre ikke tage nye klienter lige nu. Kontakt os venligst på {props.therapist.companyEmail} eller telefonnummer {props.therapist.companyPhone} for at høre, hvornår det er muligt at få en tid.</Typography>
        </>;
    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Ydelse</StyledTableCell>
                        <StyledTableCell>Behandler</StyledTableCell>
                        <StyledTableCell align="right">Varighed (min)</StyledTableCell>
                        <StyledTableCell align="right">Pris (DKK)</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map(row => (
                        <StyledTableRow key={row.name} onClick={() => props.onClick(row)}>
                            <StyledTableCell scope="row">
                                {row.name}
                            </StyledTableCell>
                            <StyledTableCell scope="row">
                                {row.nameFirst + " " + row.nameLast}
                            </StyledTableCell>
                            <StyledTableCell align="right">{row.duration / 60}</StyledTableCell>
                            <StyledTableCell align="right">{row.price}</StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
